import React from 'react';
import { Tooltip } from 'antd';
import { registrationTypeIds } from '../../constants';
import { ReactComponent as HouseOpenIcon } from '../../../../../../../resource/HouseOpenIcon.svg';
import { ReactComponent as HouseCloseIcon } from '../../../../../../../resource/HouseCloseIcon.svg';
import { ReactComponent as HouseLSIcon } from '../../../../../../../resource/HouseLSIcon.svg';
import useChangeTemplateModalVisible from '../../../../../hooks/useChangeTemplateModalVisible';
import { useSelector } from 'react-redux';

const iconComponents = {
  [registrationTypeIds.open]: HouseOpenIcon,
  [registrationTypeIds.close]: HouseCloseIcon,
  [registrationTypeIds.personalAccount]: HouseLSIcon,
};

const TypeIcon = ({ type, houseData }) => {
  const Component = iconComponents[type.id];

  const { ChangeHouseRegistrationType } = useSelector(
    (state) => state.authentication.userInfo
  );

  const { open } = useChangeTemplateModalVisible();

  const isDisabled = !ChangeHouseRegistrationType || !houseData;

  const openModal = (e, houseData) => {
    open(houseData);
    e.stopPropagation();
  };

  const handleClick = (e) => {
    e.stopPropagation();

    if (isDisabled) return null;

    openModal(e, houseData);
  };

  return Component ? (
    <Tooltip title={type.name}>
      <Component
        onClick={handleClick}
        style={{ cursor: isDisabled ? 'default' : 'pointer' }}
      />
    </Tooltip>
  ) : null;
};

export default TypeIcon;
